const doc = [({"da":({"js":({"components":({"responsive_nav":({"menu":"Menu"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;